/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Select } from "antd";

import { setDeviceMode } from "../../../actions/ui/DeviceModeActions";
import { getProjects, resetSelectedProject } from "../../../actions/projects/ProjectsActions";

import RolesHelper from "../../../services/permisions/RolesHelper";
import AccountMenu from "../../header/AccountMenu";

import DeviceModeEnum from "../../../constants/DeviceModeEnum";
import { RoutePath } from "../../../constants/SitePaths";
import ProjectStateEnum from "../../../constants/ProjectStateEnum";

const { Header } = Layout;
const { Option } = Select;

function SiteHeader() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const deviceMode = useSelector(state => state.builder.ui.deviceMode);
	const selectedProject = useSelector(state => state.builder.projects.selectedProject);
	const allProjects = useSelector(state => state.builder.projects.allProjects);
	const intl = useSelector(state => state.intl);

	const changeDeviceMode = mode => {
		dispatch(setDeviceMode(mode));
	};

	useEffect(() => {
		dispatch(getProjects());
		return () => dispatch(resetSelectedProject());
	}, []);

	const handleChangeProject = project => {
		navigate(`${RoutePath.CUSTOMIZE}/${project.key}?cid=${project.id}&p=${project.key}`);
		window.location.reload(false);
	};

	const { projects = [] } = allProjects;
	const partnersOptions =
		projects &&
		projects
			.filter(project => project.state !== ProjectStateEnum.Blocked)
			.sort((a, b) =>
				a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0,
			)
			.map(project => (
				<Option className="customization--partner" value={project.name} id={project.parrentPartnerId} key={project.id}>
					{project.name}
				</Option>
			));
	return (
		<Header className="header tb--flex tb--align-center tb--justify-between">
			{RolesHelper.isAffilateUser() ? <div /> : <Link className="logo" to="/projects" />}

			<div className="customization--device-picker">
				<a className="customization--device" onClick={() => changeDeviceMode(DeviceModeEnum.Desktop)}>
					<i className={deviceMode === DeviceModeEnum.Desktop ? "desktop-bicon active-mode" : "desktop-bicon"} />
				</a>
				<a className="customization--device" onClick={() => changeDeviceMode(DeviceModeEnum.Mobile)}>
					<i className={deviceMode === DeviceModeEnum.Mobile ? "mobile-bicon active-mode" : "mobile-bicon"} />
				</a>
			</div>

			<div className="tb--flex tb--align-center">
				<Select
					showSearch
					key={selectedProject.name}
					defaultValue={selectedProject.name}
					className="customization--partners"
					onChange={(value, selectedOption) => handleChangeProject(selectedOption)}
				>
					{partnersOptions}
				</Select>

				<div className="customization--preview tb--flex tb--align-center">
					<a
						{...(selectedProject && selectedProject.domain ? {} : { className: "tb--hidden-block" })}
						target="_blank"
						href={`//${selectedProject && selectedProject.domain}?prev=${new Date().getTime()}`}
					>
						<span className="eye-bicon-span">
							<i className="eye-bicon" />
						</span>
						{intl.messages.preview}
					</a>
				</div>

				<AccountMenu />
			</div>
		</Header>
	);
}

export default SiteHeader;
